module.exports = __webpack_public_path__ + "img/brand-eslint.3b4f6be2.svg";